<template>
  <Card>
    <span slot="title">省市区区域管理</span>
    <el-button slot="btn" icon="el-icon-refresh" @click="$refresh(getProvincesList)">刷新</el-button>
    <div slot="content" class="wrap">
      <!-- 条件查询 -->
      <div class="search">
        <el-form inline :model="searchForm">
          <el-form-item label="区域名称">
            <el-input v-model="searchForm.provincesName" placeholder="请输入区域名称"/>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" @click="$refresh(getProvincesList, true)">查询</el-button>
            <el-button icon="el-icon-refresh" @click="$reset(getProvincesList, { provincesName: '' })">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
      <!-- 操作按钮 -->
      <div class="button">
        <el-button icon="el-icon-plus" type="primary" @click="addProvinces()">新增区域</el-button>
      </div>
      <!-- 区域列表 -->
      <el-table v-loading="loading" :data="provincesList" :max-height="tableHeight" border lazy :load="treeLoad"
      :row-key="row => { return row.provincesId }" :tree-props="{children: 'children', hasChildren: 'hasChildren'}">
        <el-table-column prop="provincesName" label="区域名字"/>
        <el-table-column prop="typeStr" label="区域类型"/>
        <el-table-column label="操作" width="240">
          <template slot-scope="scope">
            <el-button type="primary" @click="addProvinces(scope.row)" icon="el-icon-plus"
              v-show="!scope.row.btnFlag">新增</el-button>
            <el-button type="danger" @click="deleteProvinces(scope.row.provincesId)"
              v-show="scope.row.btnFlag" icon="el-icon-delete">删除</el-button>
            <el-button @click="editProvinces(scope.row)" icon="el-icon-edit">编辑</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 新增或编辑弹框 -->
      <el-dialog class="dialogEdit" :title="dialogTitle" :visible.sync="dialogVisible"
        :before-close="done => $handleClose(done, 'editForm')" width="480px" :close-on-click-modal="false">
        <el-form :model="editForm" ref="editForm" :rules="editFormRules" inline>
          <el-form-item label="上级区域" prop="parentId">
            <el-select v-model="editForm.parentId" placeholder="请选择上级区域" filterable clearable default-first-option>
              <el-option v-for="item in superRegion" :key="item.value" :label="item.label" :value="item.value"/>
            </el-select>
          </el-form-item>
          <el-form-item label="区域类型" prop="type">
            <el-radio-group v-model="editForm.type" @change="typeChange">
              <el-radio :label="'0'">省份</el-radio>
              <el-radio :label="'1'">城市</el-radio>
              <el-radio :label="'2'">区/县</el-radio>
              <el-radio :label="'3'">范围</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="区域名称" prop="provincesName">
            <el-input v-model="editForm.provincesName" placeholder="请输入区域名称"/>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button type="success" v-if="dialogTitle == '新增区域'" @click="addSave">保存新增</el-button>
          <el-button type="success" v-if="dialogTitle == '编辑区域'" @click="editSave">保存修改</el-button>
          <el-button @click="$cancel('dialogVisible', 'editForm')">取 消</el-button>
        </span>
      </el-dialog>
    </div>
  </Card>
</template>

<script lang="js">
import { provincesList, provincesAdd, provincesEdit, provincesDelete } from "@/api/region"; // 获取区域请求
export default {
  name: "Provinces",
  data() {
    return {
      loading: true, // 加载中
      searchForm: { provincesName: null }, //查询表单
      provincesList: [], //区域列表
      superRegion: [{ label: "中华人民共和国", value: '0'}], // 上级区域选项
      provinceSuper: [], // 上级省区域
      citySuper: [], // 上级市区域
      regionSuper: [], // 上级区域
      dialogTitle: null, // 弹框标题
      dialogVisible: false, // 新增或编辑弹框状态
      editForm: {}, //编辑获取修改数据
      editFormRules: {
        parentId:[{ required: true, message: "上级区域不能为空", trigger: 'change'}],
        type:[{ required: true, message: "区域类型不能为空", trigger: 'change'}],
        provincesName:[{ required: true, message: "区域名称不能为空", trigger: 'blur'}]
      }, // 表单验证规则
      tableHeight: 600 // 表格最大高度
    };
  },
  created() {
    this.tableHeight = document.documentElement.clientHeight - 280;
    this.$forceUpdate();
    this.getProvincesList(); // 请求省份列表
    this.getSuperList();
  },
  methods: {
    // 请求各类区域名称列表
    async getSuperList() {
      let { rows, code } = await provincesList();
      if (code == 200) rows.forEach(item => {
        if (item.type == 0) this.provinceSuper.push({ label: item.provincesName, value: item.provincesId });
        else if (item.type == 1) this.citySuper.push({ label: item.provincesName, value: item.provincesId });
        else if (item.type == 2) this.regionSuper.push({ label: item.provincesName, value: item.provincesId });
      });
    },
    // 请求区域列表
    async getProvincesList() {
      let params = { type: !this.searchForm || (this.searchForm && !this.searchForm.provincesName) ? 0 : null, ...this.searchForm };
      let { rows, code } = await provincesList(params);
      if (code == 200) {
        rows.forEach(item => {
          item.typeStr = '省份';
          item.btnFlag = false;
          item.hasChildren = true;
        });
        this.provincesList = rows;
      }
      this.loading = false;
    },
    // 懒加载区域信息
    treeLoad(tree, treeNode, resolve) {
      setTimeout(() => {
        provincesList({parentId: tree.provincesId}).then(res => {
          if (res.code == 200) {
            res.rows.forEach(item => {
              if (item.type == 1) {
                item.hasChildren = true;
                item.btnFlag = false;
                item.typeStr = '城市';
              } else if (item.type == 2) {
                item.btnFlag = false;
                item.typeStr = '区/县';
                if (item.parentId == '510100') item.hasChildren = true;
                else item.hasChildren = false;
              } else {
                item.typeStr = '范围';
                item.hasChildren = false;
                item.btnFlag = true;
              }
            })
            resolve(res.rows);
          }
        })
      }, 30)
    },
    // 新增区域
    addProvinces(row) {
      // 值转换 及 上级目录表切换
      if (row) {
        let obj = JSON.parse(JSON.stringify(row));
        switch (obj.type) {
          case "0": obj.type = "1"; this.superRegion = this.provinceSuper; break;
          case "1": obj.type = "2"; this.superRegion = this.citySuper; break;
          case "2": obj.type = "3"; this.superRegion = this.regionSuper; break;
          case "3": break;
        }
        obj.parentId = obj.provincesId;
        this.editForm = { parentId: obj.parentId, type: obj.type, provincesName: null };
      } else {
        this.editForm = { parentId: null, type: '0', provincesName: null };
      }

      this.dialogVisible = true;
      this.dialogTitle = "新增区域";
    },
    // 保存新增
    addSave() {
      this.$refs['editForm'].validate((valid) => {
        if (valid) {
          let params = this.editForm;
          this.superRegion.forEach(item => {
            if (params.parentName == item.label) params.parentId = item.value;
          });
          provincesAdd(params).then(res => {
            let {code} = res;
            if (code == 200) this.$message.success("创建区域成功！");
            this.dialogVisible = false;
            setTimeout(() => { this.$router.go(0); }, 300)
          })
        } else return false;
      })
    },
    // 修改区域
    editProvinces(row) {
      let obj = JSON.parse(JSON.stringify(row));
      // 值转换 及 上级目录表切换
      switch (obj.type) {
        case "0": this.superRegion = [{ label: "中华人民共和国", value: 0 }]; break;
        case "1": this.superRegion = this.provinceSuper; break;
        case "2": this.superRegion = this.citySuper; break;
        case "3": this.superRegion = this.regionSuper; break;
      }
      this.editForm = obj;

      this.dialogVisible = true;
      this.dialogTitle = "编辑区域";
    },
    // 保存修改
    editSave() {
      this.$refs['editForm'].validate((valid) => {
        if (valid) {
          provincesEdit(this.editForm).then(res => {
            let {code} = res;
            if (code == 200) this.$message.success("修改区域信息成功！");
            this.dialogVisible = false;
            setTimeout(() => { this.$router.go(0); }, 300)
          })
        } else return false;
      })
    },
    // 删除区域
    async deleteProvinces(provincesId) {
      let {code} = await provincesDelete(provincesId);
      if (code == 200) {
        this.$message.success('删除区域成功！');
        setTimeout(() => { this.$router.go(0); }, 300)
      }
    },
    // 切换区域类型
    typeChange(val) {
      switch (val) {
        case "0": this.superRegion = [{ label: "中国", value: 0}]; break;
        case "1": this.superRegion = this.provinceSuper; this.editForm.parentId = this.superRegion[0]; break;
        case "2": this.superRegion = this.citySuper; this.editForm.parentId = this.superRegion[0]; break;
        case "3": this.superRegion = this.regionSuper; this.editForm.parentId = this.superRegion[0]; break;
        default: this.superRegion = [{ label: "中国", value: 0}]; break;
      }
    }
  },
};
</script>

<style lang="less" scoped>
.wrap {
  width: 100%;
  height: 100%;
  .dialogEdit {
    /deep/.el-input {
      width: 360px !important;
    }
  }
}
</style>